export enum FormTypeEnum {
    always = 'ALWAYS',
    timeIn = 'TIME_IN',
    followUp = 'FOLLOW_UP',
    questionnaire = 'QUESTIONNAIRE',
    other = 'OTHER',
    forImport = 'FOR_IMPORT',
    attendance = 'ATTENDANCE',
}
